// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export enum Operations {
    Reset,
    Stop,
    Start
}
